// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { GroupsHeader, IGroupsHeaderProps } from "./groups-header";

import { GroupList, IGroupListProps } from "./group-list";

import { IListHeaderProps, ListHeader } from 'src/components';

import { MPDList } from 'src/mpd-library';

import "./styles.css";

export interface IGroupsProps
  extends IGroupsHeaderProps,
    IGroupListProps,
    IListHeaderProps {
  history?: any;
  onSaveGroupsClick?(event: any, group: any): void;
}

interface IGroupsState {
  list: Array<any>;
  filter?: string;
  sort?: Array<string> | string;
}

export class Groups extends React.Component<IGroupsProps, IGroupsState> {

  public constructor(props: IGroupListProps) {
    super(props);
    this.onGroupsSortChange = this.onGroupsSortChange.bind(this);
    this.onGroupsSelectChange = this.onGroupsSelectChange.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onCheckBoxChange = this.onCheckBoxChange.bind(this);

    const { list } = this.props;
    this.state = {
      list,
      sort : ['title', 'description'],
    }
  }

  public render(){
    const {
      className,
      groupsSelected,
      onSaveGroupsClick, 
      onCancelClick
    } = this.props;

    const { filter, sort, list } = this.state;

    const classes = classNames("groups-container", className);

    const FilteredList = MPDList(this.renderDisplayList);

    return (
      <div className={classes}>
        <GroupsHeader
          groupsSelected={groupsSelected}
          onSaveClick={e => onSaveGroupsClick && onSaveGroupsClick(e, list)}
          onCancelClick={onCancelClick}
        />
        <ListHeader
          onGroupsSelectChange={this.onGroupsSelectChange}
          onGroupsSortChange={this.onGroupsSortChange}
          onSearchChange={this.onSearchChange}
        />
        <FilteredList
          filter={filter}
          list={list}
          sort={sort}
        />
      </div>
    );
  }

  private renderDisplayList = (props: any) => (
    <GroupList
      list={props.list}
      onAudienceBoxCheckBoxChange={this.onCheckBoxChange}
    />
  );

  private onCheckBoxChange(event: any, index: number){
    const { list } = this.state;
    list[index].checked = !list[index].checked;
    this.setState({ list });
  }

  private onSearchChange(event: any) {
    const filter = event.currentTarget.value;
    this.setState({ filter });
  }

  private onGroupsSortChange(event: any) {
    let sort = event.currentTarget.textContent;
    switch(sort) {
      case 'A-Z': 
        sort = ['title', 'description'];
        break;
      case 'Private':
        sort = 'type';
        break;
      case 'Public':
        sort = '-type';
        break;
      default:
        break;
    }
    this.setState({ sort });
  }

  private onGroupsSelectChange(event: any) {
    const { list } = this.state;
    const select = event.currentTarget.textContent;
    switch(select) {
      case 'All': 
        for (let i = 0; i < list.length; i++) {
          list[i].checked = true;
        }
        break;
      case 'None':
        for (let i = 0; i < list.length; i++) {
          list[i].checked = false;
        }
        break;
      default:
        break;
    }
    this.setState({ list });
  }
  
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/choose-audience/groups.tsx